import * as api from "~/api";
// import * as types from "./hospitalTypes";
import { HOSPITAL } from "~/utils/urlApi";
export const requestHospitalList = () => {
  return api.getHttpRequest(HOSPITAL.REQUEST_HOSPITAL_LIST_URL);
};

export const requestHospitalListByFeatureId = id => {
  return api.getHttpRequestAsync(
    HOSPITAL.REQUEST_HOSPITAL_LIST_BY_FEATURE_ID_URL(id)
  );
};

export const requestFeatureByHospitalId = id => {
  return api.getHttpRequestAsync(
    HOSPITAL.REQUEST_FEATURE_LIST_BY_HOSPITAL_ID_URL(id)
  );
};
